import React, { useEffect, useState } from "react";
import { Button } from "antd";

import { getPrinters, printPointCard } from "../../utils/Print";
import { Order } from "../../../types/model";

interface PrintPointCardButtonProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  handleError: (err: Error) => void;
  children: React.ReactNode;
  order: Order & {
    point_credit?: {
      id: string;
      claim_customer_id?: string;
    };
  };
}

const PrintPointCardButton: React.FC<PrintPointCardButtonProps> = ({
  className,
  style,
  size,
  handleError,
  children,
  order,
}) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(!order.point_credit);

  // Test to see if we can reach the print agent.
  useEffect(() => {
    getPrinters((_: any, err?: Error) => {
      if (err) {
        // Do nothing, do not enable the button.
      } else {
        setDisabled(!order.point_credit);
      }
    });
  }, [order]);

  return (
    <Button
      type="primary"
      disabled={disabled}
      loading={loading}
      className={className}
      style={style}
      size="large"
      onClick={() => {
        setLoading(true);
        printPointCard(
          order,
          () => {
            setLoading(false);
          },
          (err) => {
            setLoading(false);
            handleError(err);
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default PrintPointCardButton;
